import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import intervalPlural from 'i18next-intervalplural-postprocessor';
import loadLanguageWithFallback from './services/language-support/load-language-files';

i18n
// load translation using xhr -> see /public/locales
// learn more: https://github.com/i18next/i18next-xhr-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .use(intervalPlural)
    .init({
        lng:'en',
        fallbackLng: 'en',
        debug: true,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        backend: {
            loadPath: process.env.PUBLIC_URL+'/locales/str-{{lng}}.json'
        }
    })
    i18n.on('languageChanged', function(lng) {
            delete window.Typekit;
            loadLanguageWithFallback('str-'+lng, 'en')
            .then(({language, translations}) => {
                document.documentElement.setAttribute('lang', lng);
            })
    });;

export default i18n;
